export const RacialEnum = {
  asian: 'Amarela',
  white: 'Branca',
  indigenous: 'Indígena',
  brown: 'Parda',
  black: 'Preta',
  notInformed: 'Outra/Não deseja informar',
};
